import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<main class=\"site-content\"><div class=\"section-content\"><div class=\"container\"><div class=\"single-room-content\"><div class=\"row\"><div class=\"col-md-12\"><h1>Oops!</h1><p>The page you&#39;re looking for can&#39;t be found! <a href=\"/\">Try going back</a> and see if you can find what you&#39;re looking for!</p></div></div></div></div></div></main>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_page_header, {
      image: "window",
      title: "Oops!"
    }),
    _hoisted_1
  ]))
}